import React, { useState, useEffect } from 'react'
import styles from './OpenTaskCard.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import { SuperButton } from 'components/UI/SuperButton/SuperButton'
import { superAxiosRequest } from 'axiosApi'
import { observer } from 'mobx-react'
import useLocalization from 'hooks/useLocalization'

const OpenTaskCard = ({
  formData,
  setFormData,
  currentTask,
  onClose,
  setAllTasks,
  setCardOpen,
}) => {
  const [taskTypeError, setTaskTypeError] = useState(false)
  const [isSaveClicked, setIsSaveClicked] = useState(false)
  const [isTaskTypeSelected, setIsTaskTypeSelected] = useState(false)

  const { translate } = useLocalization({
    section: 'Crm_tasks',
    subsection: 'task',
    dict: {
      transaction_buyer: 'Contact, transaction buyer',
      task_type: 'Task type',
      period: 'Period',
      cancel: 'Cancel',
      save: 'Save',
    },
  })

  // Массив ID статусов, при которых задача считается отклоненной (скрывается)
  const REJECTED_STATUS_IDS = [3, 4]

  const handleSave = () => {
    setIsSaveClicked(true)
    setTaskTypeError(!isTaskTypeSelected)

    if (!formData.deal || !isTaskTypeSelected) {
      return
    }

    const currentDate = new Date().toISOString()

    const dataToSend = {
      ...formData,
      deal: formData?.deal?.id,
      finish_task: currentTask?.finish_task || currentDate,
      assignee: currentTask?.assignee.id,
      task_category: formData?.task_category?.id,
      comment: currentTask?.comment || null,
    }

    superAxiosRequest(
      {
        method: 'put',
        link: `tasktracker/tasks/${currentTask?.id}`,
        crm: true,
      },
      dataToSend,
    )
      .then(({ data }) => {
        if (data) {
          const newStatusId = data.status?.id || formData.status

          const isRejected = REJECTED_STATUS_IDS.includes(newStatusId)

          if (isRejected) {
            setAllTasks((prevTasks) =>
              prevTasks.filter((task) => task.id !== data.id),
            )
          } else {
            setAllTasks((prevTasks) =>
              prevTasks.map((task) =>
                task.id === data.id ? { ...task, ...data } : task,
              ),
            )
          }
        }
        setCardOpen(false)
      })
      .catch((error) => {
        console.error('Error saving task:', error)
      })
  }

  useEffect(() => {
    if (isSaveClicked) {
      setTaskTypeError(!isTaskTypeSelected)
    }
  }, [isTaskTypeSelected, isSaveClicked])

  return (
    <div className={styles.openCard}>
      <div className={styles.separator}></div>
      <div className={styles.groupForm}>
        <div className={styles.typeAndPeriod}>
          <FormField>
            <FormLabel isRequired>Выбор статуса задачи:</FormLabel>
            <SelectCustom
              placeholder={translate.task_type}
              apiLinkCRM='tasktracker/task_statuses'
              optionValueKey='id'
              optionLabelKey='name'
              valueID={formData?.status || currentTask?.status?.id}
              onChange={(status) => {
                setFormData({ ...formData, status: status.id })
                setIsTaskTypeSelected(true)
              }}
              error={isSaveClicked && taskTypeError}
            />
          </FormField>
        </div>

        <div className={styles.modalFooter}>
          <SuperButton onClick={onClose} variant='reset'>
            {translate.cancel}
          </SuperButton>
          <SuperButton onClick={handleSave} variant='confirm'>
            {translate.save}
          </SuperButton>
        </div>
      </div>
    </div>
  )
}

export default observer(OpenTaskCard)
